import { render, staticRenderFns } from "./optimiserPanelList.vue?vue&type=template&id=45e8ff7b&scoped=true&"
import script from "./optimiserPanelList.vue?vue&type=script&lang=js&"
export * from "./optimiserPanelList.vue?vue&type=script&lang=js&"
import style0 from "./optimiserPanelList.vue?vue&type=style&index=0&id=45e8ff7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8ff7b",
  null
  
)

export default component.exports